import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Fetch } from '../../utils/Utils.js';
import ListProtocols from './ListProtocols.js';
import AddProtocol from './AddProtocol.js';
import EditProtocol from './EditProtocol.js';
import { ListButton, AddButton, FAB } from '../../shared/ActionButtons';

export const Protocols = ({ screen, setScreen, recordId, actions, planType = 'iatf' }) => {
  const { state } = useLocation();
  const [localScreen, setLocalScreen] = useState("list");
  const [editingProtocol, setEditingProtocol] = useState(null);

  // Use passed screen/setScreen if provided (for hub integration), otherwise use local state
  const currentScreen = screen !== undefined ? screen : localScreen;
  const setCurrentScreen = setScreen || setLocalScreen;

  // In a hub, edit has its own URL (/…/protocols/:id/edit, see useHubScreen):
  // use the protocol handed over from the list, or load it by id when the
  // page was opened directly (refresh, link). Unknown id → back to the list.
  useEffect(() => {
    if (currentScreen !== 'edit' || !recordId || editingProtocol?._id === recordId) return;
    if (state?.protocol?._id === recordId) { setEditingProtocol(state.protocol); return; }
    Fetch(`api/data/lots.plans?search_fields=_id&search_values=${recordId}`, 'get', null,
      (data) => { const found = (data || [])[0]; if (found) setEditingProtocol(found); else setCurrentScreen('list'); },
      () => setCurrentScreen('list')
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentScreen, recordId]);

  const handleEdit = (protocol) => {
    setEditingProtocol(protocol);
    setCurrentScreen("edit", protocol._id, { protocol });
  };

  const handleEditSuccess = () => {
    setEditingProtocol(null);
    setCurrentScreen("list");
  };

  return (
    <>
      {actions && <div className="content-header">{actions}</div>}

      {(currentScreen === "list") && <ListProtocols onEdit={handleEdit} planType={planType} />}
      {(currentScreen === "list") && <FAB onClick={() => setCurrentScreen("add")} />}
      {(currentScreen === "add") &&
        <AddProtocol
          planType={planType}
          onSuccess={() => setCurrentScreen("list")}
        />
      }
      {(currentScreen === "edit") && editingProtocol &&
        <EditProtocol
          protocol={editingProtocol}
          onSuccess={handleEditSuccess}
          onCancel={() => setCurrentScreen("list")}
        />
      }
    </>
  );
}

// Action buttons component for use in hub header
export const ProtocolsActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton
      isActive={screen === "list"}
      onClick={() => setScreen("list")}
    />
    <AddButton
      isActive={screen === "add"}
      onClick={() => setScreen("add")}
    />
  </div>
);

export default Protocols;
